import { useState } from 'react';
import styles from './CbReactions.module.css';
import { emojiReactions } from './emojiReactions';
interface Props {
  onReact: (chosenReaction: string) => Promise<void>;
  reaction: string;
  isSelected: boolean;
}
const CbReactionButton = ({
  onReact,
  reaction,
  isSelected
}: Props) => {
  const [isLoading, setLoading] = useState(false);
  const handleReact = () => {
    setLoading(true);
    onReact(reaction).catch(err => console.error(err)).finally(() => setLoading(false));
  };
  return <button onClick={handleReact} disabled={isLoading} className={`${styles.emojiReactionButton} ${isSelected ? styles.emojiReactionButtonSelected : ''}`} data-sentry-component="CbReactionButton" data-sentry-source-file="CbReactionButton.tsx">
      <img className={styles.reactionMenuIcon} src={emojiReactions[reaction]} />
    </button>;
};
export default CbReactionButton;